module.exports = __webpack_public_path__ + "img/control_de_calidad_3-4_768.2b5e071c.jpg";